<!-- /**
 *
 * IMPORTANT:
 * This file is used both in vue2 and vue3
 * Dont use the vue syntax and the store concept in this file.
 * For any clarifications please contact Leela
 *
 */ -->

<template>
  <div class="voi-your-price">
    <div>
      <p v-if="youPriceValue" class="mb-0 your-price yp-wrapper">
        <span class="dollar-position font-weight-bold _theme_font_bold">$</span>
        <span class="your-price-text font-weight-bold _theme_font_bold">{{ youPriceValue }}</span>
        <span v-if="decimalValue" class="your-price-decimals font-weight-bold _theme_font_bold"
          >.{{ decimalValue }}</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    bannerdata: {
      required: true,
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      feeData: "",
      selectedPaymentFeeData: "",
      decimalValue: "",
      youPriceValue: "",
    };
  },

  async mounted() {
    if (
      (this.bannerdata?.showFeesNew &&
        this.bannerdata?.bannersPaymentHomenetVehicle?.type.toLowerCase() === "new") ||
      (this.bannerdata?.showFeesUsed &&
        this.bannerdata?.bannersPaymentHomenetVehicle?.type.toLowerCase() === "used")
    ) {
      await this.getFeesResults();
    }
    this.formatYourPrice(
      this.bannerdata?.bannersPaymentHomenetVehicle?.yourPrice,
      this.bannerdata?.enablePriceRoundOff
    );
  },
  methods: {
    async getFeesResults() {
      let accountId = window.vdpAccountId ? window.vdpAccountId : window.accountId;
      let vin = this.bannerdata.bannersPaymentHomenetVehicle?.vin;
      let response = "";
      let type = this.bannerdata?.bannersPaymentHomenetVehicle?.type;
      try {
        let url = `${atob(
          window.portalUrl
        )}OfferManager/service/CustomFee/GetFeeResults?accountid=${accountId}&vin=${vin}&type=${type}&OfferType=all`;
        response = await axios.get(url);
        if (response.data) {
          let selectedFeesDetails = this.getCustomFeesResultFromVin(response.data);
          if (!selectedFeesDetails) {
            if (type?.toLowerCase() === "new") {
              this.feeData = response.data.FeesResultNew;
            }
            if (type && type.toLowerCase() !== "new") {
              this.feeData = response.data.FeesResultUsed;
            }
          } else {
            this.feeData = selectedFeesDetails;
          }
          if (this.feeData) {
            this.filterFeeData();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    getCustomFeesResultFromVin(feesResults) {
      let vin = this.bannerdata?.bannersPaymentHomenetVehicle?.vin ?? "";
      let selectedCustomFees = "";
      if (feesResults?.CustomFeeResults?.length) {
        selectedCustomFees = feesResults.CustomFeeResults.find((result) => {
          if (result?.Vin.toLowerCase() === vin.toLowerCase()) {
            return result;
          }
        });
        return selectedCustomFees;
      }
    },

    filterFeeData() {
      if (
        this.feeData?.TotalFee_Cash &&
        this.bannerdata?.bannersPaymentHomenetVehicle?.paymentTypeToDisplay?.toLowerCase() ===
          "cash"
      ) {
        this.selectedPaymentFeeData = this.feeData.TotalFee_Cash;
      }
    },
    formatYourPrice(offerText, roundOff) {
      console.log("price format started");
      if (offerText) {
        if (this.selectedPaymentFeeData) {
          offerText = Number(offerText) + Number(this.selectedPaymentFeeData);
        }
        let [offerValue, decimalValue] = (offerText + "").split(".");
        let roundOffOfferValue = offerText;
        if (typeof offerText === "string") {
          roundOffOfferValue = offerText.replace(/,/g, "");
        }
        roundOffOfferValue = Math.round(parseFloat(roundOffOfferValue));
        this.youPriceValue = roundOffOfferValue;
        if (!roundOff) {
          this.youPriceValue = offerValue;
          this.decimalValue = decimalValue;
        }
        this.youPriceValue = this.priceFormatConversion(this.youPriceValue);
        return;
      }
      this.youPriceValue = offerText;
    },
    priceFormatConversion(value) {
      try {
        if (typeof value === "number") {
          value = value.toString();
        }
        if (value?.indexOf(",") > -1) {
          return value;
        }
        value = parseFloat(value);
        if (typeof value !== "number") {
          return value;
        }
        return value.toLocaleString();
      } catch (error) {
        console.error("Error formatting number:", error);
        return "";
      }
    },
  },
};
</script>
